import * as Yup from 'yup';

export interface IRoleTermsForm {
  termsDoctor: boolean;
}

export const initialValues: IRoleTermsForm = {
  termsDoctor: false,
};

export const validationSchema = Yup.object().shape({
  termsDoctor: Yup.boolean().oneOf([true], 'validation.required'),
});
